/* AI Visual Search: variant (size/option) picker for multi-variant products in results */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  function t(k, d) {
    try { var c = JSON.parse(document.querySelector('[data-aivs-config]').textContent); return (c.t && c.t[k]) || d; } catch (e) { return d; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function getProduct(h) {
    if (!cache[h]) cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw new Error('p'); return r.json(); });
    return cache[h];
  }
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR', v = c / 100, s;
    try { s = new Intl.NumberFormat('en', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { s = cur + ' ' + v; }
    return cur === 'PKR' ? s.replace('PKR', 'Rs.') : s;
  }
  function vopts(v) { return v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }); }
  function same(v, sel) { var o = vopts(v); for (var i = 0; i < sel.length; i++) { if (o[i] !== sel[i]) return false; } return true; }
  function find(p, sel) { for (var i = 0; i < p.variants.length; i++) { if (same(p.variants[i], sel)) return p.variants[i]; } return null; }
  function hasAvail(p, sel, i, val) { var s = sel.slice(); s[i] = val; var v = find(p, s); return !!(v && v.available); }

  function refresh(host) {
    var st = host._st, p = st.p, so = t('soldOut', 'Sold out');
    host.querySelectorAll('select[data-aivs-opt]').forEach(function (s) {
      var i = Number(s.getAttribute('data-aivs-opt'));
      s.textContent = '';
      st.vals[i].forEach(function (val) {
        var o = document.createElement('option');
        o.textContent = val + (hasAvail(p, st.sel, i, val) ? '' : ' (' + so + ')');
        if (val === st.sel[i]) o.selected = true;
        s.appendChild(o);
      });
    });
    var v = find(p, st.sel), b = host.querySelector('[data-aivs-vadd]'), pr = host.querySelector('[data-aivs-vprice]');
    host.setAttribute('data-vid', v ? v.id : '');
    pr.innerHTML = v ? esc(money(v.price)) + (v.compare_at_price > v.price ? '<s>' + esc(money(v.compare_at_price)) + '</s>' : '') : '';
    b.disabled = !(v && v.available);
    b.textContent = !v ? t('unavailable', 'Unavailable') : (v.available ? t('add', 'Add to cart') : so);
  }

  function build(host, p) {
    var names = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var vals = names.map(function (n, i) { var a = []; p.variants.forEach(function (v) { var x = vopts(v)[i]; if (a.indexOf(x) < 0) a.push(x); }); return a; });
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    host._st = { p: p, sel: vopts(first).slice(), vals: vals };
    host.textContent = '';
    names.forEach(function (n, i) {
      var l = document.createElement('label'); l.className = 'aivs-opt';
      var sp = document.createElement('span'); sp.textContent = n;
      var s = document.createElement('select'); s.setAttribute('data-aivs-opt', i);
      l.appendChild(sp); l.appendChild(s); host.appendChild(l);
    });
    var pr = document.createElement('div'); pr.className = 'aivs-vprice'; pr.setAttribute('data-aivs-vprice', '');
    var b = document.createElement('button'); b.type = 'button'; b.className = 'button button--full-width button--secondary'; b.setAttribute('data-aivs-vadd', '');
    var m = document.createElement('p'); m.className = 'aivs-vmsg'; m.setAttribute('data-aivs-vmsg', ''); m.hidden = true;
    host.appendChild(pr); host.appendChild(b); host.appendChild(m);
    refresh(host);
  }

  function setup(cell) {
    if (cell.getAttribute('data-vp')) return;
    cell.setAttribute('data-vp', '1');
    var btn = cell.querySelector('[data-add]'), link = cell.querySelector('a[href*="/products/"]');
    if (!btn || !link) return;
    var h = link.getAttribute('href'), k = h.indexOf('/products/');
    var handle = decodeURIComponent(h.slice(k + 10).split('?')[0].split('#')[0].split('/')[0]);
    getProduct(handle).then(function (p) {
      if (!p.variants || p.variants.length < 2 || !btn.parentNode) return;
      var host = document.createElement('div');
      host.className = 'aivs-var'; host.setAttribute('data-aivs-var', handle);
      btn.parentNode.replaceChild(host, btn);
      build(host, p);
    }).catch(function () {});
  }
  function scan() { document.querySelectorAll('[data-aivs-results] .aivs-cell').forEach(setup); }

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('select[data-aivs-opt]');
    if (!s) return;
    var host = s.closest('[data-aivs-var]');
    if (!host || !host._st) return;
    var st = host._st, i = Number(s.getAttribute('data-aivs-opt')), val = st.vals[i][s.selectedIndex];
    st.sel[i] = val;
    if (!find(st.p, st.sel)) {
      var c = st.p.variants.filter(function (v) { return vopts(v)[i] === val; });
      var pick = c.filter(function (v) { return v.available; })[0] || c[0];
      if (pick) st.sel = vopts(pick).slice();
    }
    var m = host.querySelector('[data-aivs-vmsg]'); if (m) m.hidden = true;
    refresh(host);
  });

  document.addEventListener('click', async function (e) {
    var b = e.target.closest && e.target.closest('[data-aivs-vadd]');
    if (!b) return;
    var host = b.closest('[data-aivs-var]'), vid = host && host.getAttribute('data-vid');
    if (!vid) return;
    var m = host.querySelector('[data-aivs-vmsg]');
    b.disabled = true;
    try {
      var r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) });
      if (!r.ok) throw new Error('cart');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      m.innerHTML = esc(t('added', 'Added')) + ' &#10003; <a href="' + root + 'cart">' + esc(t('viewCart', 'View cart')) + '</a>';
    } catch (er) { m.textContent = 'Cart me add nahi ho saka.'; }
    m.hidden = false;
    refresh(host);
  });

  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
